import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const component = ({
  photo,
  className,
  onClick,
  variants = ['fixed-width'],
}) => {
  const variantClassNames = variants.map(
    (variant) => `photo-preview--${variant}`
  );
  return (
    <a
      tabIndex="0"
      aria-label={photo.alt || ''}
      className={classNames('photo-preview', variantClassNames, className)}
      onClick={onClick}
      onKeyPress={(e) => {
        // console.log(e.key);
        if (e.key === 'Enter') {
          onClick();
        }
      }}
    >
      <div className="photo-preview__overlay" aria-label={photo.alt || ''}>
        <span className="icon-camera" aria-label={'Camera Icon'}></span>
        <br />
        <span className="photo-preview__link">Details</span>
      </div>
      <img
        src={photo.preview}
        aria-label={photo.alt || ''}
        alt={photo.alt || ''}
        className="photo-preview__image"
      />
    </a>
  );
};

component.displayName = 'PhotoPreview';
export default component;



// WEBPACK FOOTER //
// ./client/components/PhotoPreview/index.js